<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-08-05 09:25:41
 * @LastEditTime : 2022-08-12 14:40:49
 * @LastEditors  : yangxr
 * @Description  : 甲供工程
 * @FilePath     : \icps_fb\src\views\platform\ICPS\GHnumber\firstSupplyEngineering.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="tabtop" style="width: 376px">
        <div @click="handleClick(1)">
          <div :class="currenindex === 1 ? 'active' : 'text'">未绑定</div>
        </div>
        <div @click="handleClick(2)">
          <div :class="currenindex === 2 ? 'active' : 'text'">已绑定</div>
        </div>
      </div>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div>
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px">工程名称:</span>
                  <el-input v-model="tableParam.engineeringName" style="width: 240px" clearable />
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" >
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                    <el-link v-if=" item.label == '合同ID'" :underline="false" @click="goContract(scope.row)">
                        {{ scope.row[item.prop] }}
                    </el-link>
                    <span v-else >{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from "@/api/GHnumber/firstEngin.js";
export default {
  mixins: [mixin],
  data() {
    return {
        table:[
        { label: "工程编号", prop: "engineeringCode", status: true,width:"auto" },
        { label: "工程名称", prop: "engineeringName", status: true,width:"200" },
        { label: "合同单位", prop: "roadwork", status: true,width:"150" },
        { label: "时间", prop: "discloseCreateTIme", status: true,width:"150" },
        { label: "责任销售", prop: "saller", status: true,width:"auto" },
        { label: "责任预算", prop: "budgetPerson", status: true,width:"auto" },
        { label: "供应单位", prop: "supplyUnit", status: true,width:"auto" },
        { label: "联系人", prop: "supplyContacts", status: true,width:"auto" },
        { label: "联系方式", prop: "contactsMode", status: true,width:"auto" },
        { label: "甲供材料名称", prop: "rawName", status: true,width:"auto" },
        { label: "型号", prop: "specification", status: true,width:"auto" },
        { label: "单方掺量信息", prop: "mixingAmount", status: true,width:"auto" },
        { label: "合同ID", prop: "cotractCode", status: true,width:"auto" },
        // { label: "绑定状态", prop: "type", status: true,width:"150" },
        ],
        queryPage:queryPage,
        tableData:[],
        pagesType:0,
        currenindex:1,
        startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
    };
  },
  watch: {
  },
  async created() {
    this.tableParam = { ...this.tableParam, engineeringName:"",type:1 };
    this.gettableData();

  },
  methods: {
      //点击合同ID
      goContract(row){
          this.$router.push({name:'GHnumberContractcontract',query:{contractId:row.contractId}})
      },
      //切换tabs
      handleClick(index) {
      this.tableParam.type = index;
      this.currenindex = index;
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>

